import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import { FirestoreService } from './firestore/firestore.service';
import { Router } from '@angular/router';

interface User {
    email: string;
    groups?: any;
    lastName?: string;
    name?: string;
    initials: string;
    password?: string;
    photoUrl: any;
    createdAt?: any;
    updatedAt?: any;
}

interface UserId extends User {
    id: string;
}

@Injectable()
export class UserService {

    collection: string;

    constructor(
        private afh: FirestoreService,
        private afs: AngularFirestore,
        private router: Router
    ) {
        this.collection = Globals.USER_COLLECTION;
    }

    getUsers() {
        console.log(this.collection);
        return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true));
        //return this.users;
    }

    existUser(email: string) {
        let userCollection = this.afs.collection(this.collection, ref => ref.where('email', '==', email));

        let users = userCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;
                return { id$ };
            });
        }).map(object => object);

        return users;
    }

    /**
    * Create new user
    * @param {User} user - The data of the user
    */
    addUser(user: User) {
      this.afh.add(`${this.collection}`, user);
      this.router.navigate(['/users']);
    }
  
    /**
     * Update current user
     * @param {string} sid  - The id of the user
     * @param {User} user - The data of the user
     */
    updateUser(sid: string, user) {
      this.afh.update(`${this.collection}/${sid}`, user);
      this.router.navigate(['/users']);
    }

    delUser(id$: string) {
        let userDocument = this.afs.doc(this.collection + '/' + id$);

        return userDocument.update({ active: false, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });

    }

    getUser(id: string) {
        return this.afh.docWithIds$(`${this.collection}/${id}`);
    }

    loginUser(userEmail: string, userPassword: string) {
        let userCollection = this.afs.collection(this.collection, ref => ref.where('email', '==', userEmail).where('password', '==', userPassword));

        let users = userCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as User;

                const password = data.password;

                return { id$, password };
            });
        }).map(object => object);

        return users;
    }

    getUserByEmailPassword(email: string, password: string){
        return this.afh.colWithIds$(this.collection, ref => ref.where('email', '==', email).where('password', '==', password) );
    }
    getUserByEmail(email: string){
        return this.afh.colWithIds$(this.collection, ref => ref.where('email', '==', email) );
    }

}
